var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-group',[_c('p',[_vm._v("Routers:")]),_vm._l((_vm.routersLibres),function(router){return _c('v-list-item',{key:router.id,attrs:{"value":router.id},on:{"click":function($event){return _vm.onRouterSelected(router)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(router.num_router))])],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }